import React from "react";

import moment from "moment";

import { SPEC_FLAGS_MAP } from "../../../../../../Common/constants/SpecFlagConstants";
import { useAccessStatus } from "../../../../../../grace-period/hooks/useAccessStatus";
import { getVisibleSpecFlag } from "../../../../../../grace-period/utils";

import { ReactComponent as StatusDotIcon } from "../../../../../../../assets/images/environment/statusPingDot.svg";

export default function DateCard({
  report,
  index,
  activeReportIdx,
  setActiveReportIdx,
}) {
  const { areResultsLocked } = useAccessStatus();
  const { color } = SPEC_FLAGS_MAP[getVisibleSpecFlag(report.specs_flag, areResultsLocked)] ?? SPEC_FLAGS_MAP.invalid;

  return (
    <div
      className={activeReportIdx === index ? "env-report-view-date-card selected-date-card" : "env-report-view-date-card"}
      onClick={() => setActiveReportIdx(index)}
    >
      <div className="date-header">{moment(report.received_date).format("DD MMMM")}</div>
      <div className="test-spec-section">
        <div className="test-section">
          <span className="num-tests-text">{`${report.test_total_counts < 10 ? 0 : ""}${report.test_total_counts}`}</span>
          <span>:</span>
          <span>Tests</span>
        </div>
        <div className="vertical-line" />
        <StatusDotIcon width={16} height={16} fill={color} />
      </div>
    </div>
  );
}
